// import Notify from '../../../../../../components/Commons/Notify';
import { Enviroment } from "../../../../_config/constants/enviroment-v2.constant";
import { AxiosAdapter } from "../../../../_config/v2/adapters/axios/axios.adapter";
import { Http } from "../../../../_config/v2/adapters/axios/axios.protocols";

export class Service {
	async getBagOnDemand(item) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/shop-car/${item}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error);
				// Notify({
				// 	title: 'Problemas de Conexión',
				// 	colorTitle: 'ph-main-notification-error-title',
				// 	description: 'Revisa tu conexión o ponte en contacto con nosotros',
				// 	time: 4,
				// 	image: 'error',
				// 	placement: 'topRight',
				// });
				return null;
			});
	}
}
